import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { pillarArticles } from "@/mocks/articles";

export default function ArticleEntry() {
  const { t } = useTranslation();

  return (
    <section className="bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">
            {t("articles.title")}
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            {t("articles.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {pillarArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/guides/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-white transition-transform duration-200 hover:-translate-y-1 cursor-pointer"
            >
              <div className="h-44 w-full overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={t(`${article.keyPrefix}.title`)}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="inline-flex self-start rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                  {t(`${article.keyPrefix}.category`)}
                </span>
                <h3 className="mt-3 text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {t(`${article.keyPrefix}.title`)}
                </h3>
                <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {t(article.excerptKey)}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                  {t("articles.card.readMore")}
                  <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}